<svg width="17" height="22" viewBox="0 0 17 22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M14.213 10.569c-.009-1.639.741-2.876 2.259-3.787-.85-1.2-2.132-1.861-3.826-1.991-1.603-.125-3.356.924-3.997.924-.677 0-2.231-.88-3.45-.88C2.678 4.876 0 6.824 0 10.784c0 1.17.217 2.379.65 3.626.578 1.639 2.665 5.657 4.842 5.59 1.138-.027 1.942-.8 3.424-.8 1.436 0 2.181.8 3.45.8 2.195-.031 4.083-3.684 4.634-5.327-2.945-1.37-2.787-4.018-2.787-4.103zm-2.556-7.332C12.89 1.791 12.777.473 12.741 0c-1.089.063-2.349.732-3.067 1.558-.79.884-1.255 1.978-1.156 3.21 1.179.09 2.254-.508 3.139-1.53z" id="w17wap2h4a"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="q32yt2gmxb" fill="#fff">
            <use xlink:href="#w17wap2h4a"/>
        </mask>
        <use fill="#000" fill-rule="nonzero" xlink:href="#w17wap2h4a"/>
        <g mask="url(#q32yt2gmxb)" fill="currentColor">
            <path d="M-2.06 0h20.605v20H-2.06z"/>
        </g>
    </g>
</svg>
